import { render, staticRenderFns } from "./DesktopPriceFeature.vue?vue&type=template&id=cfd9d13c&scoped=true&"
import script from "./DesktopPriceFeature.vue?vue&type=script&lang=ts&"
export * from "./DesktopPriceFeature.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopPriceFeature.vue?vue&type=style&index=0&id=cfd9d13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd9d13c",
  null
  
)

component.options.__file = "DesktopPriceFeature.vue"
export default component.exports